import * as BenefitsWrapper from './BenefitsWrapper'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/benefits' instead.
 */

export const Benefits = BenefitsWrapper
